import React from 'react'
import { TouchableOpacity } from 'react-native'
import Styles from './style'
import Typography from 'APP/Converse/Typography'

const ToolButton = ({
  title,
  onPress,
  disabled,
}: {
  title: string
  onPress: () => void
  disabled?: boolean
}) => (
  <TouchableOpacity
    style={Styles.button}
    onPress={onPress}
    disabled={disabled}
    testID={`TOOL-BUTTON-${title}`}
  >
    <Typography style={disabled ? Styles.buttonTextDisabled : Styles.buttonText}>
      {title}
    </Typography>
  </TouchableOpacity>
)

export default ToolButton
